import { useNavigate } from 'react-router-dom';
import { PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import { Icon, ICONS, PLATFORM_THEME_COLORS, Popover } from '@thinknet-gmbh/platform-common-ui';

import { useUserCanManageDocument } from 'src/hooks/user-can-manage-document.hook';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';
import { PROCESS_TEMPLATES_MODALS } from '../../process-templates.constants';

import { IProcessesTemplateTableRowProps } from './process-templates-table.interfaces';

const ProcessTemplatesTableRowActions = ({
  record,
  handleModals,
  t,
}: IProcessesTemplateTableRowProps) => {
  const navigate = useNavigate();
  const { canDelete, canEdit } = useUserCanManageDocument({
    platformPermission: PLATFORM_PERMISSIONS.processBuilder,
  });

  const handleEdit = () => {
    if (canEdit) {
      navigate(`${ROUTES.settings}?type=${SETTINGS_PAGES.processTemplates}&id=${record._id}`);
    }
  };

  return (
    <Popover
      elements={[
        {
          label: t('common:buttons.edit'),
          icon: ICONS.editAlt,
          key: ICONS.editAlt,
          ...(!canEdit && { color: PLATFORM_THEME_COLORS.grayVariations.murky }),
          handler: handleEdit,
        },
        {
          label: t('common:buttons.delete'),
          icon: ICONS.trash,
          color: canDelete
            ? PLATFORM_THEME_COLORS.tone.red
            : PLATFORM_THEME_COLORS.grayVariations.murky,
          key: ICONS.trash,
          handler: () => {
            if (canDelete) {
              handleModals(PROCESS_TEMPLATES_MODALS.delete, record);
            }
          },
        },
      ]}
    >
      <Icon
        icon={ICONS.dotsVerticalRounded}
        size={22}
        color={PLATFORM_THEME_COLORS.primary.grey}
        rightMargin={false}
      />
    </Popover>
  );
};

export default ProcessTemplatesTableRowActions;
